import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HeaderPremium from "./components/HeaderPremium";
import MarketTicker from "./components/MarketTicker";
import HeroPremium from "./components/HeroPremium";
import SegmentedEntry from "./components/SegmentedEntry";
import AuthorityStrip from "./components/AuthorityStrip";
import BrandStatement from "./components/BrandStatement";
import FeaturedReportsPremium from "./components/FeaturedReportsPremium";
import PlatformValue from "./components/PlatformValue";
import ReportPreview from "./components/ReportPreview";
import UserJourneyPremium from "./components/UserJourneyPremium";
import ConversionPremium from "./components/ConversionPremium";
import FooterPremium from "./components/FooterPremium";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ResearchDashboard from "./pages/ResearchDashboard";
import SectorIntelligence from "./pages/SectorIntelligence";
import LegalIntelligence from "./pages/LegalIntelligence";
import Learning from "./pages/Learning";
import UPSC from "./pages/UPSC";
import AuthCallback from "./pages/AuthCallback";
import Pricing from "./pages/Pricing";
import Subscription from "./pages/Subscription";
import Profile from "./pages/Profile";
import AdminReports from "./pages/AdminReports";
import SubscriptionReportViewer from "./pages/SubscriptionReportViewer";
import RefundPolicy from "./pages/RefundPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import PublicReportPage from "./pages/PublicReportPage";

const LandingPage = () => {
  return (
    <main>
      <HeroPremium />
      <FeaturedReportsPremium />
    </main>
  );
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AppRouter = () => {
  const location = useLocation();
  // Synchronous detection during render (NOT in useEffect) to avoid race conditions
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/equity-intelligence" element={<ResearchDashboard />} />
      <Route path="/equity" element={<Navigate to="/equity-intelligence" replace />} />
      <Route path="/sector-intelligence" element={<SectorIntelligence />} />
      <Route path="/legal-intelligence" element={<LegalIntelligence />} />
      <Route path="/professional-intelligence" element={<Learning />} />
      <Route path="/professional" element={<Navigate to="/professional-intelligence" replace />} />
      <Route path="/civil-services-intelligence" element={<UPSC />} />
      <Route path="/research" element={<Navigate to="/equity-intelligence" replace />} />
      <Route path="/market-intelligence" element={<Navigate to="/equity-intelligence" replace />} />
      <Route path="/sector" element={<Navigate to="/sector-intelligence" replace />} />
      <Route path="/legal" element={<Navigate to="/legal-intelligence" replace />} />
      <Route path="/learning" element={<Navigate to="/professional-intelligence" replace />} />
      <Route path="/upsc" element={<Navigate to="/civil-services-intelligence" replace />} />
      <Route path="/civil-services" element={<Navigate to="/civil-services-intelligence" replace />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/cancellation" element={<CancellationPolicy />} />
      <Route path="/cancellation-policy" element={<CancellationPolicy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/disclaimer-policy" element={<Disclaimer />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/equity/:slug" element={<PublicReportPage />} />
      <Route path="/sector/:slug" element={<PublicReportPage />} />
      <Route path="/legal/:slug" element={<PublicReportPage />} />
      <Route path="/upsc/:slug" element={<PublicReportPage />} />
      <Route path="/premium-reports" element={<Navigate to="/equity-intelligence" replace />} />
      <Route path="/admin" element={<AdminReports />} />
      <Route path="/subscription-reports/:reportId" element={<SubscriptionReportViewer />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen bg-[#F7F5F2]">
          <HeaderPremium />
          <MarketTicker />
          <div className="pt-[124px]">
            <AppRouter />
          </div>
          <FooterPremium />
          <Toaster />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
